import React from "react"

import { FEATURES_TYPE, HOME_ROUTES } from '@constants'
import AppLayout from "Layout"
import HomePage from "Pages/Main/Home"
import SearchAnalyticsPage from './Page'
import { Navigate } from 'react-router-dom'


export const HomeRoute = {
	id: FEATURES_TYPE.COMMON,
	path: HOME_ROUTES.PATH,
	title: HOME_ROUTES.TITLE,
	icon: 'house',
	element: <AppLayout/>,
	children: [{
		element: <Navigate to={HOME_ROUTES.HOME_PATH} replace />,
		index: true
	}, {
		element: <HomePage/>,
		path: HOME_ROUTES.HOME_PATH,
		title: HOME_ROUTES.HOME_TITLE,
	}, {
		path: HOME_ROUTES.SEARCH_ANALYTICS_PATH,
		title: HOME_ROUTES.SEARCH_ANALYTICS_TITLE,
		element: <SearchAnalyticsPage/>
	}]
}